<template>
  <zb-radio-group
    :action="plansAction"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-for="slot in Object.keys({...$scopedSlots, ...$slots})" :slot="slot" slot-scope="scope">
      <slot :name="slot" v-bind="scope"></slot>
    </template>
  </zb-radio-group>
</template>
<script>
import ZbRadioGroup from '@/components/zoom-ui-plus/radio/radio-group.vue';

export default {
  name: 'CycleRadioGroup',
  props: {
    plans: Array,
    action: Function,
  },
  methods: {
    plansAction(oldVal, val) {
      const oldPlan = this.plans.find(item => item.billing_cycle === oldVal);
      const newPlan = this.plans.find(item => item.billing_cycle === val);
      return this.action(oldPlan, newPlan);
    }
  },
  components: {
    ZbRadioGroup,
  },
}
</script>
